import { gpcListener } from './lib';

gpcListener().then();
